// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--AKdeX","aside":"_6c97079b1b--aside--3mYtS","main":"_6c97079b1b--main--3EiaS","header":"_6c97079b1b--header--12G7r"};